import { Component, Input, OnInit } from '@angular/core';

import { IconTypeEnum } from '~/component/icon/enums/icon-type.enum';
import { SocialButtonVariantEnum } from '~/component/social-button/enums/variant.enum';
import { SocialButtonConfigInterface } from '~/component/social-buttons/interfaces/social-button.config.interface';
@Component({
  selector: 'app-sharer-buttons',
  templateUrl: './sharer-buttons.component.html',
})
export class SharerButtonsComponent implements OnInit {
  @Input() public description = '';
  @Input() public url = '';
  @Input() public variant = SocialButtonVariantEnum.Primary;

  public readonly buttonsConfig: SocialButtonConfigInterface[] = [
    {
      iconType: IconTypeEnum.Facebook,
      nameKey: 'component.sharer_buttons.facebook',
      name: 'facebook',
      isShareButton: true,
    },
    {
      iconType: IconTypeEnum.Messenger,
      nameKey: 'component.sharer_buttons.messenger',
      name: 'messenger',
      isShareButton: true,
    },
    {
      iconType: IconTypeEnum.Link,
      nameKey: 'component.sharer_buttons.link',
      name: 'copy',
      isShareButton: true,
    },
    {
      iconType: IconTypeEnum.Whatsapp,
      nameKey: 'component.sharer_buttons.whatsapp',
      name: 'whatsapp',
      isShareButton: true,
    },
  ];

  public ngOnInit(): void {
    this.buttonsConfig.forEach((buttonConfig) => (buttonConfig.url = this.url));
  }
}
